export default "__VITE_ASSET__C63BC2Z1__"